import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  getDashboardStatistics
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setStatisticsDashboard
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {getDashboardStatisticsApi} from '../api/statiestics';

export const loadStatisticsAction = (from?: string, to?: string): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getDashboardStatistics;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getDashboardStatisticsApi(from, to);

      dispatch(finishLoadingAction(actionKey));
      dispatch(setStatisticsDashboard(data));
    } catch (e) {
      console.log('loadStatisticsAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadStatisticsDashboardAsyncAction,
        actionKey,
        error: e
      }));
    }
  }
});
